import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NbThemeService } from '@nebular/theme';
import { ToastService } from '../../@theme/service/toast.service';
import { AuthConfigService } from '../../common/service/auth-config.service';
import { AuthService } from '../../common/service/auth.service';
import { LeakedFileCheker } from '../../common/tasker/leaked-file-checker';
import { Accounts } from '../../common/util/accounts';
import { EncryptRSA } from '../../common/util/encrypt-rsa.util';
import { Account } from '../account/account';


@Component({
  selector: 'ngx-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  public account: Account = new Account();
  public submitted = false;
  public theme: any;

  constructor(
    private router: Router,
    private authService: AuthService,
    private themeService: NbThemeService,
    private toastService: ToastService,
    private authConfigService: AuthConfigService,
    private leakedFileChecker: LeakedFileCheker
  ) {}

  ngOnInit() {

    Accounts.clearAll();

    this.leakedFileChecker?.stop();

    sessionStorage.removeItem("account")

    this.theme = localStorage.getItem('theme');
    if (!this.theme) {
      this.theme = 'dark';
      localStorage.setItem('theme', this.theme);
    }
    this.themeService.changeTheme(this.theme);
  }

  login() {
    this.submitted = true;

    this.authConfigService.getConfig().subscribe((config) => {
      if (config && config.result) {
        if (!config.data) {
          this.submitted = false;
          this.toastService.showToast(
            'warning',
            '로그인에 실패했습니다.',
            '로그인 서버에 연결할 수 없습니다.',
          );

        }

        const encryptor = new EncryptRSA(config.data);

        this.authService.login(encryptor.encrypt(this.account.email), encryptor.encrypt(this.account.pw)).subscribe(
              (res) => {
                if (!res || !res.result || !res.data) {
                  this.toastService.showToast('warning', res.message, '');
                  this.submitted = false;
                  return;
                }
        
                const account: Account = Accounts.getAccount();
        
                if (account.permission === 'ADMIN') {
                  this.router.navigate(['pages/dashboard']);
                } else {
                  this.router.navigate(['pages/dashboard']);
                }
              },
              (e: any) => {
                this.submitted = false;
                this.toastService.showToast(
                  'warning',
                  '로그인에 실패했습니다.',
                  '로그인 서버에 연결할 수 없습니다.',
                );
              },
            );
      } else {
        this.submitted = false;
        this.toastService.showToast(
          'warning',
          '로그인에 실패했습니다.',
          '로그인 서버에 연결할 수 없습니다.',
        );
      }
    }, error => {
      this.submitted = false;
      this.toastService.showToast(
        'warning',
        '로그인에 실패했습니다.',
        '로그인 서버에 연결할 수 없습니다.',
      );
    });
    
  }

  getConfigValue(obj: any) {
    return obj;
  }
}
